import { useI18n } from '@/ui/i18n/I18nProvider';
import styles from './ErrorScreen.module.css';

/** S01 — unsupported browser or boot failure. Never blames the player; saves are untouched. */
export function ErrorScreen({ kind }: { kind: 'unsupported' | 'error' | 'saveFuture' }) {
  const { t } = useI18n();
  const prefix = {
    unsupported: 'system.webgl_unsupported',
    error: 'system.boot_failed',
    saveFuture: 'system.save_future',
  }[kind];
  return (
    <div className={styles.screen} role="alert">
      <div className={styles.card}>
        <h1 className={styles.title}>{t(`${prefix}.title`)}</h1>
        <p>{t(`${prefix}.body`)}</p>
        <button
          type="button"
          className={styles.button}
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('system.reload')}
        </button>
      </div>
    </div>
  );
}
